export default Object.freeze({
  StepNumber: 1,
  ProgressBar: 2,
});
